import React, {useState} from 'react';
import {Tooltip} from 'antd';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {
  StyledInvoiceDocumentCard,
  StyledInvoiceDocumentCardPreview,
  StyledInvoiceDocumentCardDownloadButton
} from './StyledInvoiceDocumentCard';
import {DownloadIcon} from '../../../../icons';
import {invoicesActions} from '../../../../state/actions/invoice.actions';
import {fileHelpers, systemHelpers} from '../../../../utils/helpers';
import {firebaseEvents} from '../../../../snippets/firebase';

const InvoiceDocumentCard = ({
  edit = true,
  invoice,
  dispatch,
  downloadInvoice,
  ...rest
}) => {
  const [t] = useTranslation(['main', 'invoices']);
  const [downloadProgress, setDownloadProgress] = useState(false);

  const handleDownload = () => {
    if (!invoice?.id) return;

    setDownloadProgress(true);
    downloadInvoice(
      invoice.id,
      (data) => {
        fileHelpers.saveFile(data);
        setDownloadProgress(false);
        systemHelpers.logEvent(firebaseEvents.INVOICES_DOWNLOAD_INVOICE);
      },
      () => setDownloadProgress(false)
    );
  }

  const extra = invoice?.id ? (
    <Tooltip title={t('download')}>
      <StyledInvoiceDocumentCardDownloadButton
        loading={downloadProgress}
        onClick={handleDownload}
        type='text'
      >
        <DownloadIcon />
      </StyledInvoiceDocumentCardDownloadButton>
    </Tooltip>
  ) : undefined;

  const attachment = {
    file: invoice?.file_url,
    name: invoice?.file_name
  }

  return (
    <StyledInvoiceDocumentCard
      title={t('invoices:originalInvoiceName')}
      {...rest}
      extra={extra}
    >
      <StyledInvoiceDocumentCardPreview
        attachment={attachment}
        multiple={true}
      />
    </StyledInvoiceDocumentCard>
  );
}

InvoiceDocumentCard.propTypes = {
  edit: PropTypes.bool,
  invoice: PropTypes.shape({
    file_name: PropTypes.string,
    file_url: PropTypes.string,
  })
}

const mapDispatchToProps = {
  downloadInvoice: invoicesActions.downloadInvoice,
}

export default connect(null, mapDispatchToProps)(InvoiceDocumentCard);

